import { Injectable, NgZone } from '@angular/core'
import { Router } from '@angular/router'

import { SmartLink } from '../interfaces/smart-link.interface'
import { IncentiveFamily } from '../enums/incentive.family'

@Injectable({
  providedIn: 'root'
})
export class SmartLinkService {
  constructor(private router: Router, private ngZone: NgZone) {
    // Force reload if navigate to same state.
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false
    }
  }

  // Navigates to link page.
  goToLink(link: SmartLink, selectedFamily?: IncentiveFamily): void {
    const path: string = this.generatePath(link, selectedFamily)

    this.ngZone.run(() => {
      this.router.navigateByUrl(path, {})
    })
  }

  generatePath(link: SmartLink, family?: IncentiveFamily): string {
    let path = ``

    switch (link.view) {
      case 'countryPage': {
        const countryId = link.params.find((p) => p.name === 'countryId')?.value
        path += `/countries/${countryId}`
        break
      }
      case 'incentiveDatabase': {
        path += this.router
          .createUrlTree(['incentives'], {
            queryParams: {
              ...link.params.reduce(
                (acc: { [key: string]: string }, param) => {
                  acc[param.name] = param.value
                  return acc
                },
                {}
              ),
              dataset: family
            }
          })
          .toString()
        break
      }
      case 'incentiveDetails': {
        const incentiveId = link.params.find((p) => p.name === 'incentiveId')?.value
        path += `/incentives/${incentiveId}`
        break
      }
    }
    return path
  }
}
